import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
const regularWorker = new Worker("/workers/worker.js");

@Component({})
export default class TitleMixin extends Vue {
  newNameSpace = "";
  created() {
    this.$store.dispatch("WorkerStore/setWorkerAction", regularWorker);
    document.title = window.location.host.includes("hawkings.education") ? "hawkings.education" : "nubi.city";
    regularWorker.onmessage = function (e) {
      if (e.data.result.includes("undefined")) {
        regularWorker.postMessage({
          title: window.location.host.includes("hawkings.education") ? "hawkings.education" : "nubi.city",
          nameSpace: e.data.result.replace("undefined", ''),
        });
      } else document.title = e.data.result;
    };
    this.InitialWorker();
  }
  InitialWorker(): void {
    regularWorker.postMessage({
      title: this.getUrl(),
      nameSpace: this.spaceName,
    });
    if (this.newNameSpace == "")
      setTimeout(() => {
        this.InitialWorker();
      }, 5000);
  }
  get spaceName(): string {
    const space = this.$store.getters["SpaceStore/getSpace"];
    const name = space ? " - " + space.name : "";
    this.newNameSpace = name;
    return name;
  }
  getTitle() {
    return document.title;
  }
  getUrl() {
    return window.location.host.includes("hawkings.education") ? "hawkings.education" : "nubi.city";
  }
}
